import React, { useState, useEffect, useRef } from "react";
import "../styles/clients.scss";
import MenuBottomBar from "../components/menuBottomMobile";
import FavWantAds from "../components/WantAdListing/PublishedWantAds";
import { classesBasedOnScroll, getUserId, getUserType, isIphone } from "../../helpers/common";
import { FREE_PLAN, PUBLISHED_TAB, SCROLL_DIRECTION_DOWN, USER_TYPE_AGENT, USER_TYPE_MEMBER } from "../../constants/common";
import {
  favouriteWantAd,
  getFavouriteWantAdList,
  unFavouriteWantAd,
  unfavouriteAllWantAd,
} from "../../services/wantAdService";
import Sortoffcanvas from "../components/Common/Sortoffcanvas";
import DeleteFavouriteModal from "../components/Favorites/DeleteFavouriteModal";
import { listContext } from "../../contextApi/wantAdListContext";
import { useNavigate } from "react-router-dom";
import { useLocation } from "react-router-dom";
import { pageURLs } from "../../constants/pageURLs";
import { toast } from "react-toastify";
import PropertyListingHeader from "../components/PropertyListingHeader";
import userProfile from "../../appState/userProfile";
import HandleScroll from "../commonComponents/HandleScroll";

const WantAdFavorites = () => {
  const scrollStates = HandleScroll()
  const isReachedBottom =  _.get(scrollStates, 'isReachedBottom', null)
  const scrollDirection = _.get(scrollStates, 'direction', null)
  const navigate = useNavigate();
  const location = useLocation();
  const scrollRef = useRef(null);
  const PAGE_LIMIT = 10;
  const INITIAL_PAGE_INDEX = 1;
  const clientName = location && location?.state?.clientName;
  const clientId = location && location?.state?.clientId;
  const favCount = location && location?.state?.favCount;
  const isFromClientDashboard = location && location?.state?.isFromClientDashboard;
  const userType = getUserType()

 
  const initialListStates = {
    activeTab: PUBLISHED_TAB,
    currPage: INITIAL_PAGE_INDEX,
    list: null,
  };
  const toastId = useRef(null);
  const favListSortoptions = [
    {
      value: "recently added",
      label: "Recently Favorited",
      sortDir: "desc",
    },
    { value: "newest", label: "Newest", sortDir: "desc" },
    { value: "oldest", label: "Oldest", sortDir: "asc" },
    { value: "price", label: "Price(low-high)", sortDir: "asc" },
  ];
  
  const [showDeleteModal, setDeleteModal] = useState(null);
  const [listStates, setListStates] = useState(initialListStates);
  const [favListSort, setFavListSort] = useState(favListSortoptions[0]);
  const [showSort, setShowSort] = useState(false);
  const [adCount, setAdCount] = useState(false);
  const [userPlanDetails, setUserPlanDetails] = useState(false);
  const sortClose = () => setShowSort(false);
  const sortShow = () => setShowSort(true);
  const userDetails = userProfile()

  useEffect(()=>{
    setUserPlanDetails(userDetails)
  },[userDetails])

  useEffect(() => {
    // console.log(`#####clientName`, clientName)
    // if(userType === USER_TYPE_AGENT && !clientName){
    //   navigate(pageURLs.clientFavoriteSummary)
    // }
    setAdCount(favCount)
    document.body.classList.add("bg-offcanvas-fix");
  }, []);


  useEffect(() => {
    if (isReachedBottom) {
      setListStates((prevState) => ({
        ...prevState,
        currPage: prevState.currPage + 1,
      }));
    }
  }, [isReachedBottom]);

  useEffect(() => {
    const reqPayload = {
      page: listStates.currPage,
      limit: PAGE_LIMIT,
      clientId: clientId,
      sortBy: favListSort?.value,
      sortDir: favListSort?.sortDir,
    };
    getFavWantAdList(reqPayload);
  }, [listStates.currPage, favListSort]);

  const getFavWantAdList = async (reqPayload) => {
    await getFavouriteWantAdList(reqPayload)
      .then((response) => {
        if (response.errorCode === 0 && _.get(response, "result", null)) {
          const list = _.get(response, "result", null)?.map(item => ({
            ...item,
            isFav: true,
          }));
          const currPage = reqPayload.page;
          if (currPage === INITIAL_PAGE_INDEX) {
            setListStates((prevState) => ({
              ...prevState,
              list: list,
            }));
          } else {
            setListStates((prevState) => ({
              ...prevState,
              list: [...prevState.list, ...list],
            }));
          }
        }
      })
      .catch((err) => {
        console.log("Error", err);
      });
  };

 

  /**
   * Delete action
   */
  const handleDelete = async () => {
    let data = {
      clientId: clientId ? clientId : null,
    };
    await unfavouriteAllWantAd(data)
      .then((response) => {
        if (response.errorCode == 0) {
          toast.success(`${clientName} Favorites folder has been cleared.`);
          setDeleteModal(false);
          navigate(pageURLs.clientFavoriteSummary);
        } else {
          console.log("Something went wrong");
        }
      })
      .catch((err) => {
        console.log("Error", err);
      });
  };

  const toastMessage = (Want_ad_Id, IsFavourite) => {
    let message =
      IsFavourite == true
        ? "Want-Ad has been removed from your favorites"
        : "Want-Ad has been added to your favorites";
    return (
      <div className="d-flex align-items-center justify-content-between">
        <span className="d-flex flex-grow-1">{message}</span>

        <button
          className="btn-primary text-nowrap me-2"
          onClick={(e) =>
            handleFavoriteWantAd(Want_ad_Id, e, !IsFavourite)
          }
        >
          {" "}
          Undo
        </button>
      </div>
    );
  };
  
  const buildClientCondition = (isFav) =>{
    if(isFav){
      if(clientId){
        return clientId
      } else{
        return null
      }
    } else{
      if(clientId){
        return [clientId]
      } else{
        return []
      }
    }
  }

  const handleFavoriteWantAd = async (Want_ad_Id, e, isFav) => {
    e.stopPropagation();
    if (Want_ad_Id) {
      let data = {
        clientId: buildClientCondition(isFav),
        wantAdId: Want_ad_Id,
      };
      await (isFav? unFavouriteWantAd(data): favouriteWantAd(data))
        .then((response) => {
          if (response.errorCode == 0) {
            toast.dismiss(toastId.current);
            toast.success(toastMessage(Want_ad_Id, isFav), {
              toastId: response.result.wantAdId,
            });
           
            const currentAdList = [..._.get(listStates, "list", [])];
            const currentUpdatedItem = currentAdList?.find(obj => obj.Want_ad_Id === Want_ad_Id);
            if (isFav) {
              if (currentUpdatedItem) {
                currentUpdatedItem['isFav'] = false;
              }
              setAdCount((prevState) => prevState - 1);
            } else {
              if (currentUpdatedItem) {
                currentUpdatedItem['isFav'] = true;
              }
              setAdCount((prevState) => prevState + 1);
            }

            setListStates((prevState) => ({
              ...prevState,
              list: currentAdList,
            }));
          } else {
            console.log("Something went wrong");
          }
        })
        .catch((err) => {
          console.log("Error", err);
        });
    }
  };

  const handleSortSelection = (selectedParam) => {
    sortClose();
    setFavListSort(selectedParam);
    setListStates((prevState) => ({
      ...prevState,
      currPage: INITIAL_PAGE_INDEX,
      list: null,
    }));
  };

  const handleBackClick = () => {
    if(userType === USER_TYPE_MEMBER){
      navigate(pageURLs.proDashboard)
    } else{
      if(userPlanDetails !== null && userPlanDetails.length>0){
        if(userPlanDetails[0]?.period &&  userPlanDetails[0]?.period === FREE_PLAN){
          navigate(pageURLs.proDashboard)
        } else{
          if(isFromClientDashboard){
            navigate(pageURLs.viewClientDetailsMob, { state: { clientId: clientId }})
          } else{
            navigate(pageURLs.clientFavoriteSummary)
          }
         
        }
      } 
    }
   
  };

  // let mainWrapperClass ="gitcha-main-wrapper my-client-wrap view-client-wrap pb-90 windowscroll-fix"
  // let contentWrapperClass = "content-wrapper content-wrapper-h-90-percent windowscroll-fix"
  // if(scrollDirection === SCROLL_DIRECTION_DOWN){
  //   if(isIphone()){
  //     mainWrapperClass ="gitcha-main-wrapper my-client-wrap view-client-wrap pb-90-iphone-fix windowscroll-fix"
  //   } else{
  //     mainWrapperClass ="gitcha-main-wrapper my-client-wrap view-client-wrap pb-90 windowscroll-fix"
  //   }
  //    contentWrapperClass = "content-wrapper h-100 windowscroll-fix"
  // }
  const {mainWrapperClass, contentWrapperClass } = classesBasedOnScroll(scrollDirection)

  return (
    <div className={mainWrapperClass}>
      <div className={contentWrapperClass}>
        <div className="inner-layout-header-new bg-white">
          <div className="top-three-comp-header w-100 top-three-comp-headerborder">
            <div className="top-three-comp-header-inner w-100">
              <a
                className="back-link-btn"
                href={void 0}
                role="button"
                onClick={() => handleBackClick()}
              >
                <svg
                  width="20"
                  height="20"
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M10.1003 5.39972C10.3932 5.69262 10.3932 6.16749 10.1003 6.46038L5.31066 11.2501H20.5C20.9142 11.2501 21.25 11.5858 21.25 12.0001C21.25 12.4143 20.9142 12.7501 20.5 12.7501H5.31066L10.1003 17.5397C10.3932 17.8326 10.3932 18.3075 10.1003 18.6004C9.80744 18.8933 9.33256 18.8933 9.03967 18.6004L2.96967 12.5304C2.82902 12.3897 2.75 12.199 2.75 12.0001C2.75 11.8011 2.82902 11.6104 2.96967 11.4697L9.03967 5.39972C9.33256 5.10683 9.80744 5.10683 10.1003 5.39972Z"
                    fill="#1B1C1E"
                  />
                </svg>
              </a>
              <div className="heading">
                {clientName ? clientName + " Favorites" : "My Favorites"}
              </div>
              <div className="right-mobbtn-wrap">
                <a
                  className="action-btn"
                  href={void 0}
                  role="button"
                  onClick={() =>
                    clientName ? setDeleteModal(true) : sortShow()
                  }
                >
                  {clientName ? (
                    <svg
                      width="20"
                      height="20"
                      viewBox="0 0 20 20"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M9.99979 1.66699C8.53799 1.66699 7.32079 2.75926 7.11649 4.16699H4.26574C4.23025 4.16092 4.19431 4.15793 4.15832 4.15804C4.12721 4.15871 4.0962 4.1617 4.06554 4.16699H2.70812C2.6253 4.16582 2.54307 4.18112 2.46622 4.21201C2.38936 4.24289 2.31941 4.28874 2.26043 4.34689C2.20145 4.40505 2.15462 4.47434 2.12265 4.55075C2.09068 4.62716 2.07422 4.70916 2.07422 4.79199C2.07422 4.87482 2.09068 4.95682 2.12265 5.03323C2.15462 5.10964 2.20145 5.17894 2.26043 5.23709C2.31941 5.29525 2.38936 5.3411 2.46622 5.37198C2.54307 5.40286 2.6253 5.41816 2.70812 5.41699H3.59923L4.64822 16.2625C4.76117 17.432 5.7547 18.3337 6.92931 18.3337H13.0694C14.2441 18.3337 15.2376 17.4321 15.3505 16.2625L16.4003 5.41699H17.2915C17.3743 5.41816 17.4565 5.40286 17.5334 5.37198C17.6102 5.3411 17.6802 5.29525 17.7391 5.23709C17.7981 5.17894 17.845 5.10964 17.8769 5.03323C17.9089 4.95682 17.9254 4.87482 17.9254 4.79199C17.9254 4.70916 17.9089 4.62716 17.8769 4.55075C17.845 4.47434 17.7981 4.40505 17.7391 4.34689C17.6802 4.28874 17.6102 4.24289 17.5334 4.21201C17.4565 4.18112 17.3743 4.16582 17.2915 4.16699H15.9348C15.8685 4.15624 15.8009 4.15624 15.7346 4.16699H12.8831C12.6788 2.75926 11.4616 1.66699 9.99979 1.66699ZM9.99979 2.91699C10.7828 2.91699 11.4251 3.44539 11.6087 4.16699H8.3909C8.57447 3.44539 9.2168 2.91699 9.99979 2.91699ZM4.85412 5.41699H15.1446L14.1062 16.1421C14.0541 16.6817 13.6114 17.0837 13.0694 17.0837H6.92931C6.38809 17.0837 5.94458 16.681 5.89253 16.1421L4.85412 5.41699ZM8.53169 7.49137C8.36607 7.49396 8.20825 7.56218 8.09289 7.68105C7.97754 7.79991 7.91408 7.9597 7.91645 8.12533V14.3753C7.91528 14.4581 7.93058 14.5404 7.96147 14.6172C7.99235 14.6941 8.0382 14.764 8.09635 14.823C8.15451 14.882 8.2238 14.9288 8.30021 14.9608C8.37662 14.9928 8.45862 15.0092 8.54145 15.0092C8.62428 15.0092 8.70628 14.9928 8.78269 14.9608C8.85911 14.9288 8.9284 14.882 8.98655 14.823C9.04471 14.764 9.09056 14.6941 9.12144 14.6172C9.15232 14.5404 9.16762 14.4581 9.16645 14.3753V8.12533C9.16765 8.04167 9.15205 7.95863 9.12056 7.88112C9.08908 7.80361 9.04235 7.73321 8.98316 7.67409C8.92396 7.61497 8.8535 7.56834 8.77595 7.53695C8.6984 7.50557 8.61534 7.49007 8.53169 7.49137ZM11.4484 7.49137C11.2827 7.49396 11.1249 7.56218 11.0096 7.68105C10.8942 7.79991 10.8307 7.9597 10.8331 8.12533V14.3753C10.8319 14.4581 10.8472 14.5404 10.8781 14.6172C10.909 14.6941 10.9549 14.764 11.013 14.823C11.0712 14.882 11.1405 14.9288 11.2169 14.9608C11.2933 14.9928 11.3753 15.0092 11.4581 15.0092C11.5409 15.0092 11.623 14.9928 11.6994 14.9608C11.7758 14.9288 11.8451 14.882 11.9032 14.823C11.9614 14.764 12.0072 14.6941 12.0381 14.6172C12.069 14.5404 12.0843 14.4581 12.0831 14.3753V8.12533C12.0843 8.04167 12.0687 7.95863 12.0372 7.88112C12.0057 7.80361 11.959 7.73321 11.8998 7.67409C11.8406 7.61497 11.7702 7.56834 11.6926 7.53695C11.6151 7.50557 11.532 7.49007 11.4484 7.49137Z"
                        fill="#1B1C1E"
                      />
                    </svg>
                  ) : (
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="20"
                      height="20"
                      viewBox="0 0 20 20"
                      fill="none"
                    >
                      <path
                        d="M10 10C10 10.1658 9.93415 10.3247 9.81694 10.4419C9.69973 10.5592 9.54076 10.625 9.375 10.625H3.75C3.58424 10.625 3.42527 10.5592 3.30806 10.4419C3.19085 10.3247 3.125 10.1658 3.125 10C3.125 9.83424 3.19085 9.67527 3.30806 9.55806C3.42527 9.44085 3.58424 9.375 3.75 9.375H9.375C9.54076 9.375 9.69973 9.44085 9.81694 9.55806C9.93415 9.67527 10 9.83424 10 10ZM3.75 5.625H14.375C14.5408 5.625 14.6997 5.55915 14.8169 5.44194C14.9342 5.32473 15 5.16576 15 5C15 4.83424 14.9342 4.67527 14.8169 4.55806C14.6997 4.44085 14.5408 4.375 14.375 4.375H3.75C3.58424 4.375 3.42527 4.44085 3.30806 4.55806C3.19085 4.67527 3.125 4.83424 3.125 5C3.125 5.16576 3.19085 5.32473 3.30806 5.44194C3.42527 5.55915 3.58424 5.625 3.75 5.625ZM8.125 14.375H3.75C3.58424 14.375 3.42527 14.4408 3.30806 14.5581C3.19085 14.6753 3.125 14.8342 3.125 15C3.125 15.1658 3.19085 15.3247 3.30806 15.4419C3.42527 15.5592 3.58424 15.625 3.75 15.625H8.125C8.29076 15.625 8.44973 15.5592 8.56694 15.4419C8.68415 15.3247 8.75 15.1658 8.75 15C8.75 14.8342 8.68415 14.6753 8.56694 14.5581C8.44973 14.4408 8.29076 14.375 8.125 14.375ZM17.9422 12.6828C17.8841 12.6247 17.8152 12.5786 17.7393 12.5472C17.6635 12.5157 17.5821 12.4995 17.5 12.4995C17.4179 12.4995 17.3365 12.5157 17.2607 12.5472C17.1848 12.5786 17.1159 12.6247 17.0578 12.6828L15 14.7414V8.75C15 8.58424 14.9342 8.42527 14.8169 8.30806C14.6997 8.19085 14.5408 8.125 14.375 8.125C14.2092 8.125 14.0503 8.19085 13.9331 8.30806C13.8158 8.42527 13.75 8.58424 13.75 8.75V14.7414L11.6922 12.6828C11.5749 12.5655 11.4159 12.4997 11.25 12.4997C11.0841 12.4997 10.9251 12.5655 10.8078 12.6828C10.6905 12.8001 10.6247 12.9591 10.6247 13.125C10.6247 13.2909 10.6905 13.4499 10.8078 13.5672L13.9328 16.6922C13.9909 16.7503 14.0598 16.7964 14.1357 16.8279C14.2115 16.8593 14.2929 16.8755 14.375 16.8755C14.4571 16.8755 14.5385 16.8593 14.6143 16.8279C14.6902 16.7964 14.7591 16.7503 14.8172 16.6922L17.9422 13.5672C18.0003 13.5091 18.0464 13.4402 18.0779 13.3643C18.1093 13.2885 18.1255 13.2071 18.1255 13.125C18.1255 13.0429 18.1093 12.9615 18.0779 12.8857C18.0464 12.8098 18.0003 12.7409 17.9422 12.6828Z"
                        fill="#1B1C1E"
                      />
                    </svg>
                  )}
                </a>
              </div>
            </div>
          </div>
        </div>
        <div
          className="home-layout-content"
        >
          <div className="tab-wrap tab-wrap-fix favorite-padding-fix">
            {clientName && (
              <PropertyListingHeader
                title={`${adCount} Favorited Want-Ads`}
                sortParam={favListSort}
                titleClass="d-flex pb-3 pt-2"
                handleSortParam={handleSortSelection}
                options={favListSortoptions}
              />
            )}

            <listContext.Provider
              value={{
                list: _.get(listStates, "list", null)?.filter(function (ca) {
                  return ca.isFav === true ;
                }),
                status: PUBLISHED_TAB,
                isFromFavorite: true,
                handleFavoriteWantAd,
                clientId: clientId,
                clientName: clientName,
                favCount: favCount
              }}
            >
              <FavWantAds />
              {/* <div className="test-height-class"></div> */}
            </listContext.Provider>
          </div>
        </div>
      </div>
      {scrollDirection !== SCROLL_DIRECTION_DOWN && (
          <div className="inner-layout-footer-new inner-layout-footer-topfix">
            <div className="bottomMenu bottom-menu-index">
              <MenuBottomBar scrollDirection = {scrollDirection} />
            </div>
          </div>
        )}
      <Sortoffcanvas
        show={showSort}
        onHide={sortClose}
        handleSortParam={handleSortSelection}
        options={favListSortoptions}
        sortParam={favListSort}
      />
      {showDeleteModal && (
        <DeleteFavouriteModal
          show={showDeleteModal}
          onHide={setDeleteModal}
          handleDelete={handleDelete}
        />
      )}
    </div>
  );
};

export default WantAdFavorites;
